var canvas = document.getElementById('signature-canvas');
var hiddenInput = document.getElementById('signature');
var clearBtn = document.getElementById('signature-clear-btn');

var ctx = canvas.getContext('2d');
var drawing = false;
var lastX = 0,
  lastY = 0;

function initCanvas() {
  var rect = canvas.getBoundingClientRect();
  canvas.width = Math.round(rect.width);
  canvas.height = Math.round(rect.height);
  applyStyle();
}

function applyStyle() {
  ctx.strokeStyle = '#000';
  ctx.lineWidth = 2;
  ctx.lineCap = 'round';
  ctx.lineJoin = 'round';
}

function getPos(e) {
  var rect = canvas.getBoundingClientRect();
  var src = e.touches ? e.touches[0] : e;
  return { x: src.clientX - rect.left, y: src.clientY - rect.top };
}

function onStart(e) {
  e.preventDefault();
  drawing = true;
  var pos = getPos(e);
  lastX = pos.x;
  lastY = pos.y;
}

function onMove(e) {
  if (!drawing) return;
  e.preventDefault();
  var pos = getPos(e);
  ctx.beginPath();
  ctx.moveTo(lastX, lastY);
  ctx.lineTo(pos.x, pos.y);
  ctx.stroke();
  lastX = pos.x;
  lastY = pos.y;
  hiddenInput.value = canvas.toDataURL();
}

function onEnd() {
  drawing = false;
}

canvas.addEventListener('mousedown', onStart);
canvas.addEventListener('mousemove', onMove);
canvas.addEventListener('mouseup', onEnd);
canvas.addEventListener('mouseleave', onEnd);
canvas.addEventListener('touchstart', onStart, { passive: false });
canvas.addEventListener('touchmove', onMove, { passive: false });
canvas.addEventListener('touchend', onEnd);

clearBtn.addEventListener('click', function () {
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  hiddenInput.value = '';
});

initCanvas();
